import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import CarrierGuardFreightDetailsService from '../services/CarrierGuardFreightDetailsService';

export const CARRIER_GUARD_FREIGHT_DETAILS_QUERY_KEY = '3rd-party-management-fetch-carrier-guard-freight-details';

const useCarrierGuardFreightDetails = ({
    freightId,
    t,
}) => {
    return useQuery({
        queryKey: [CARRIER_GUARD_FREIGHT_DETAILS_QUERY_KEY, freightId],
        queryFn: async () => {
            const service = CarrierGuardFreightDetailsService.getInstance();

            return await service.fetchDetails(freightId);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: !!freightId,
        onError: () => {
            toast(t('An error occurred while fetching freight details.'), {
                type: 'error',
            });
        },
    });
};

export default useCarrierGuardFreightDetails;
